import React from "react";
import CatalogArea from "../../components/CatalogArea";
import { ScrollToTopOnMount } from "../../components/common/ScrollToTopOnMount";
import Footer from "../../components/Footer";
import ItemDetailContainer from "../../components/ItemDetailContainer";

const Detail = () => {
  return (
    <div>
      <ScrollToTopOnMount />
      <ItemDetailContainer />
      <CatalogArea />
      <Footer />
    </div>
  );
};

export default Detail;
